var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.allAuthUser
        ? _c(
            "p",
            {
              staticClass: "process_list",
              staticStyle: {
                "background-color": "#fff5e6",
                "border-color": "#ffebcc",
                padding: "5px",
                "margin-bottom": "10px"
              }
            },
            [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { color: "#f8b762", margin: "0 10px" }
              }),
              _c("span", { staticClass: "process_list_num" }, [_vm._v("1")]),
              _vm.isInDingTalk
                ? _c("span", [_vm._v("创建组织架构")])
                : _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.junziqian.com/help_detail-32.html",
                        target: "_blank"
                      }
                    },
                    [_vm._v("创建组织架构")]
                  ),
              _c("i", { staticClass: "el-icon-right icon_size" }),
              _c("span", { staticClass: "process_list_num" }, [_vm._v("2")]),
              _vm.isInDingTalk
                ? _c("span", [_vm._v("邀请企业成员加入")])
                : _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.junziqian.com/help_detail-33.html",
                        target: "_blank"
                      }
                    },
                    [_vm._v("邀请企业成员加入")]
                  ),
              _c("i", { staticClass: "el-icon-right icon_size" }),
              _c("span", { staticClass: "process_list_num" }, [_vm._v("3")]),
              _vm.isInDingTalk
                ? _c("span", [_vm._v("为成员分配权限")])
                : _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.junziqian.com/help_detail-36.html",
                        target: "_blank"
                      }
                    },
                    [_vm._v("为成员分配权限")]
                  )
            ]
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          staticStyle: {
            "background-color": "#ffffff",
            "min-height": "calc(100vh - 210px)"
          },
          model: {
            value: _vm.tabAct,
            callback: function($$v) {
              _vm.tabAct = $$v
            },
            expression: "tabAct"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "组织及成员", name: "member" } },
            [_vm.tabAct === "member" ? _c("member-com") : _vm._e()],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "权限组", name: "role" } },
            [_c("role-com")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-154dae0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-154dae0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/member.vue
// module id = bFqn
// module chunks = 7 40